'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumWait = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx("path", {
            d: "M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM8 3.724C8.387 3.724 8.7 4.037 8.7 4.424V7.3H11.576C11.963 7.3 12.276 7.613 12.276 8C12.276 8.387 11.963 8.7 11.576 8.7H8C7.613 8.7 7.3 8.387 7.3 8V4.424C7.3 4.037 7.613 3.724 8 3.724Z",
            fill: "currentColor"
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsxs("g", {
                    clipPath: "url(#clip0_4702_8492)",
                    children: [
                        jsxRuntime.jsx("circle", {
                            cx: "8",
                            cy: "8",
                            r: "7.3",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinejoin: "round"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M8 4.42352V7.99999H11.5765",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                }),
                jsxRuntime.jsx("defs", {
                    children: jsxRuntime.jsx("clipPath", {
                        id: "clip0_4702_8492",
                        children: jsxRuntime.jsx("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

module.exports = MediumWait;
